import { ThemeContext } from '@f_context/Theme_context';
import { WorkPeriod } from '@f_general/WorkPeriod';
import { useWindowSize } from '@f_hooks/index';
import { QwepContext } from '@f_qwep/context/Qwep_context';
import useQwepNavigate from '@f_qwep/hooks/useQwepNavigate';
import stls from '@f_qwep/styles/component/header/HeaderComponent.module.sass';
import { useContext, useEffect, useState } from 'react';
import { IconBasket } from '../icons/IconBasket';
import { Library } from '../manual/Library';
import { ShowErrors } from './ShowErrors';

export function HeaderComponent() {
    const navigate = useQwepNavigate();
    const { colors } = useContext(ThemeContext);
    const { applicationInfoLoading, workPeriod } = useContext(QwepContext);
    const [mobile, setMobile] = useState(false);
    const { width } = useWindowSize();

    useEffect(() => {
        setMobile(width < 480);
    }, [width]);

    return (
        <div className={stls.container}>
            {mobile && (
                <button id="basket" onClick={() => navigate('basket')}>
                    <IconBasket color={colors.epsilon} height="24" width="24" />
                </button>
            )}
            <div className={stls.item}>
                <WorkPeriod
                    loading={applicationInfoLoading}
                    workPeriod={workPeriod?.slice(9).split('-').reverse().join('-')}
                />
            </div>
            <div className={stls.item}>
                <ShowErrors />
            </div>
            <div className={stls.item}>
                <Library />
            </div>
        </div>
    );
}
